import { createSelector } from 'reselect';
import { RootState } from '../state';
import { UserRoleType } from './types';

export const selectIsUserAdmin = createSelector([(state: RootState) => state.user.userInfo], (user) =>
  !user ? false : user.userRole.find((role) => [UserRoleType.SystemAdmin, UserRoleType.ProjectAdmin].includes(role.name))
);

export const isUserSubcontractor = createSelector([(state: RootState) => state.user.userInfo], (user) =>
  user ? user.userRole?.some((role) => role.name === UserRoleType.Subcontractor) : false
);

export const isReadAllRole = createSelector([(state: RootState) => state.user.userInfo], (user) =>
  user ? user.userRole?.some((role) => role.name === UserRoleType.ReadAll) : false
);
